import { NO_ELEMENT } from 'utils';

export const SiteModeModal = () => NO_ELEMENT;
